import { polygon, center, lineString, length, point, booleanContains, } from "@turf/turf";
import { throwGlobalError } from "../utils/helpers";
export class CampusCollection {
    constructor() {
        this.campuses = [];
        this.currentCampus = null;
        this.allCampusNodes = new Map();
    }
    /**
     * Diese Funktion sorgt dafür, dass wenn ein zIndex reinkommt der einem Stockwerk entspricht,
     * dann wird er umgewandelt in den eigentlichen Array Index von diesem Stockwer. Nur so kann usePosition.sideEffects.js
     * den Punkt richtig anzeigen (ghosting)
     */
    getIndexFromLevel(level) {
        try {
            let index = -1;
            this.getCurrentCampus().floors.forEach((item, i) => {
                if (item.stockwerk == level)
                    index = i;
            });
            return index;
        }
        catch (e) {
            throwGlobalError("Fehler bei campus.getIndexFromLevel -> 0 returned", e);
            return 0;
        }
    }
    addCampus(campus) {
        // duplikate vermeiden
        if (!this.campuses.find((c) => c.id === campus.id)) {
            this.campuses.push(campus);
        }
    }
    setCurrentCampus(campusId) {
        var _a;
        this.prevCampusId = (_a = this.currentCampus) === null || _a === void 0 ? void 0 : _a.id;
        this.campuses.forEach((c) => {
            if (+c.id === +campusId) {
                this.currentCampus = c;
            }
        });
    }
    setCampusPolygon(campusId, polygonArray) {
        this.campuses.forEach((c) => {
            if (c.id === campusId) {
                let polygonFeature = polygon(polygonArray);
                c.polygon = polygonFeature;
                if (c.center && c.center.lng != null && c.center.lat != null) {
                }
                else {
                    let polygonCenter = center(polygonFeature);
                    c.center = {
                        lng: polygonCenter.geometry.coordinates[0],
                        lat: polygonCenter.geometry.coordinates[1],
                    };
                }
            }
        });
    }
    getCurrentCampus() {
        if (this.currentCampus != null) {
            return this.currentCampus;
        }
        else {
            return this.campuses[0];
        }
    }
    getLevelByIndex(floorIndex, getDisplayLevel = false, campus = this.getCurrentCampus()) {
        var _a;
        const floors = campus.floors;
        if (floorIndex == null || floorIndex < 0) {
            console.log("floorindex invalide", floorIndex);
            return (_a = floors[0]) === null || _a === void 0 ? void 0 : _a.stockwerk;
        }
        if (floorIndex > floors.length - 1) {
            console.log("floorindex overflowed -> fallback letzter");
            return floors[floors.length - 1].stockwerk;
        }
        const indexedFloor = floors[floorIndex];
        if (!getDisplayLevel || indexedFloor.kundeStockwerkAnzeige == null) {
            return indexedFloor.stockwerk;
        }
        else if (indexedFloor.kundeStockwerkAnzeige !== undefined) {
            return indexedFloor.kundeStockwerkAnzeige;
        }
        else
            return 0;
    }
    getLevelDisplayType(level, displayType = "kundeStockwerkAnzeige", campus = this.getCurrentCampus()) {
        const levelIndex = this.getIndexFromLevel(level);
        const floors = campus.floors;
        const indexedFloor = floors[levelIndex];
        if (floors && indexedFloor != null) {
            if (indexedFloor[displayType]) {
                return indexedFloor[displayType];
            }
            else {
                return indexedFloor.stockwerk;
            }
        }
        else {
            console.warn("Achtung keine Floors vorhanden");
            return undefined;
        }
    }
    /**
     * Gibt den am naheliegstensten Campus zu gegebenen Koordinaten
     */
    getClosestCampusTo(lngLat) {
        let shortestDistanceCampus = {
            distance: 0,
            campus: null,
        };
        this.campuses.forEach((c) => {
            let centerCampus = c.center;
            let lineCampusToCoordinates = lineString([
                [centerCampus.lng, centerCampus.lat],
                lngLat,
            ]);
            let distance = length(lineCampusToCoordinates);
            if (shortestDistanceCampus.campus == null ||
                shortestDistanceCampus.distance >= distance) {
                shortestDistanceCampus = { campus: c, distance: distance };
            }
        });
        if (shortestDistanceCampus.campus != null) {
            return shortestDistanceCampus.campus;
        }
        else
            return null;
    }
    isCorrdOnCurrentCampus(coordinate) {
        if (!this.currentCampus)
            return false;
        if (!coordinate)
            return false;
        const coord = point(coordinate);
        if (this.currentCampus.polygon == null) {
            console.warn(`Campus ${this.currentCampus.id} hat kein Polygon`);
            return false;
        }
        else {
            let line = lineString([
                ...this.currentCampus.polygon.geometry.coordinates[0],
            ]);
            return booleanContains(line, coord);
        }
    }
    getCampusById(campusId) {
        return this.campuses.find((c) => +c.id === +campusId);
    }
    getCampusByKey(key) {
        return this.campuses.find((c) => c.campusKey === key);
    }
    getAllCampuses() {
        return this.campuses;
    }
    getAllCampusNodes() {
        if (!this.allCampusNodes.size) {
            this.campuses.forEach((campus) => campus.nodes.forEach((nodeArray) => {
                if (nodeArray.properties) {
                    nodeArray.properties.campusId = campus.id;
                }
                this.allCampusNodes.set(nodeArray.properties.id, nodeArray);
            }));
            this.allCampusNodes = this.allCampusNodes;
            return this.allCampusNodes;
        }
        else {
            return this.allCampusNodes;
        }
    }
}
export class Campus {
    constructor(id, campusKey, name, nodes, beacons, floors, center, polygon, showRoomnames, showOutdoorEinrichtungenOnMap, showAdressenOnMap) {
        this.id = id;
        this.name = name;
        this.campusKey = campusKey;
        if (name)
            this.name = name;
        this.nodes = nodes;
        this.beacons = beacons;
        this.floors = floors;
        this.center = center;
        this.polygon = polygon;
        this.showRoomnames = showRoomnames;
        this.showOutdoorEinrichtungenOnMap = showOutdoorEinrichtungenOnMap;
        this.showAdressenOnMap = showAdressenOnMap;
    }
    getPolygon() {
        if (this.polygon) {
            return this.polygon;
        }
        else
            return null;
    }
    hasLevel(level) {
        if (!this.floors) {
            return false;
        }
        let hasLevel = false;
        this.floors.forEach((floor) => {
            if (floor.stockwerk === level) {
                hasLevel = true;
            }
        });
        return hasLevel;
    }
    getLevels() {
        return this.floors.map((l) => {
            return l.stockwerk;
        });
    }
    getCenter() {
        return this.center;
    }
    /** Returns the "starting" Floor. The one where people usually enter the building in */
    getGroundFloor() {
        return this.floors.find((f) => f.isGroundFloor);
    }
}
